// extracted by mini-css-extract-plugin
export default {"iconSuccess":"_2iYyg","success-icon":"_2DAfU","savePersonalDataBtn":"_25kVN"};